import { useParams } from 'react-router-dom';

import { AppCreateAdPage } from '~/components/pages/AppCreateAdPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateAdRoute: React.FC = () => {
  const { appId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppCreateAdPage appId={appId} />
    </DashboardTemplate>
  );
};
